import { useMemo } from 'react'
import { useDateTimeFormatters } from '@/lib/i18n/useDateTimeFormatters'

export type UpcomingDayFormat = ReturnType<typeof useUpcomingDayFormat>

/** Next 7 days labels in the user's locale and clock (no fixed date-fns patterns). */
export function useUpcomingDayFormat() {
  const { date, time } = useDateTimeFormatters()
  return useMemo(() => {
    const at = (value: Date | number) => (typeof value === 'number' ? new Date(value) : value)
    return {
      weekdayLong: (value: Date | number) => date(at(value), { weekday: 'long' }),
      weekdayShort: (value: Date | number) => date(at(value), { weekday: 'short' }),
      monthDay: (value: Date | number) => date(at(value), { month: 'short', day: 'numeric' }),
      weekdayMonthDay: (value: Date | number) => date(at(value), { weekday: 'short', month: 'short', day: 'numeric' }),
      weekdayLongMonthDay: (value: Date | number) => date(at(value), { weekday: 'long', month: 'short', day: 'numeric' }),
      dayNum: (value: Date | number) => date(at(value), { day: 'numeric' }),
      time: (value: Date | number) => time(at(value), { hour: 'numeric', minute: '2-digit' }),
    }
  }, [date, time])
}
